import { Fragment } from "react";
import { useSelector } from "react-redux";
import { DescriptionItem } from "./Item";
import { selectDescriptionDetails } from "../../../../util/selectors";

function DescriptionDetails({ year, period, baseId, sx, ...rest }) {
  const details = useSelector((state) =>
    selectDescriptionDetails(state, year, period)
  );
  return (
    <Fragment>
      {details.map(({ label, value }, index) => {
        return (
          <DescriptionItem
            {...rest}
            key={encodeURIComponent(label + value + index)}
            label={label}
            value={value}
          />
        );
      })}
    </Fragment>
  );
}

export default DescriptionDetails;
